import Dim from './Dim';

export default Dim;
export * as DimStyles from './Dim.styles';
export * as DimTypes from './Dim.types';
